import { FORM_VALIDATION_MSG } from "../constants";
const getDefaultEditReasonInfo = (data) => {
  return {
    editReasonCode: data?.editReasonCode ?? "",
    contactName: data?.contactName ?? "",
    callTime: data?.callTime ?? "",
    comments: data?.comments ?? "",
  };
};

const getDefaultEditReasonErrorInfo = () => {
  return {
    editReasonCode: "",
    contactName: "",
    callTime: "",
    comments: "",
  };
};

const getEditReasonError = (value, isDateTimeUpdated) => {
  if (!value && isDateTimeUpdated) {
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getCommentsError = (value, editReasonInfo) => {
  if (editReasonInfo.editReasonCode && !value) {
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getContactNameError = (value, editReasonInfo) => {
  if (editReasonInfo.editReasonCode === "2" && !value) {
    //contact name and call time fields are required only if editReasonCode is 2 i.e "Customer changed"
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getCallTimeError = (value, editReasonInfo) => {
  return getContactNameError(value, editReasonInfo);
};

const getFieldError = ({
  fieldName,
  value,
  isDateTimeUpdated,
  editReasonInfo,
}) => {
  switch (fieldName) {
    case "editReasonCode":
      return getEditReasonError(value, isDateTimeUpdated);
    case "contactName":
      return getContactNameError(value, editReasonInfo);
    case "callTime":
      return getCallTimeError(value, editReasonInfo);
    case "comments":
      return getCommentsError(value, editReasonInfo);
  }
};
const getEditReasonErrorInfo = (editReasonInfo, isDateTimeUpdated) => {
  let errorInfo = {};
  Object.keys(editReasonInfo).forEach((fieldName) => {
    errorInfo[fieldName] = getFieldError({
      fieldName,
      value: editReasonInfo[fieldName],
      isDateTimeUpdated,
      editReasonInfo,
    });
  });
  return errorInfo;
};
export {
  getDefaultEditReasonInfo,
  getDefaultEditReasonErrorInfo,
  getFieldError,
  getEditReasonErrorInfo,
};
